import React from 'react';
import { CartLine } from '../newOrderTypes';
import styles from './ConfirmStep.module.css';

interface ConfirmStepProps {
  cart: CartLine[];
  customerName: string;
}

const formatCurrency = (n: number) => `$${n.toFixed(2)}`;

export const ConfirmStep: React.FC<ConfirmStepProps> = ({ cart, customerName }) => {
  const subtotal = cart.reduce((s, l) => s + l.product.rawPrice * l.qty, 0);
  const totalItems = cart.reduce((s, l) => s + l.qty, 0);

  return (
    <div className={styles.wrap}>
      <div className={styles.successCircle}>
        <svg viewBox="0 0 24 24" fill="currentColor" width="40" height="40">
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
        </svg>
      </div>
      <h3 className={styles.title}>Ready to Submit</h3>
      <p className={styles.subtitle}>Review your order details one last time</p>

      <div className={styles.card}>
        <h4 className={styles.cardTitle}>👤 Customer Details</h4>
        <p className={styles.customerName}>{customerName || '—'}</p>
      </div>

      <div className={styles.card}>
        <h4 className={styles.cardTitle}>📦 Order Summary</h4>
        <div className={styles.row}>
          <span>Total Items</span>
          <span className={styles.bold}>{totalItems} items</span>
        </div>
        <div className={styles.row}>
          <span>Order Value</span>
          <span className={styles.bold}>{formatCurrency(subtotal)}</span>
        </div>
        <div className={styles.row}>
          <span>Estimated Margin</span>
          <span className={styles.green}>—</span>
        </div>
        <div className={styles.totalRow}>
          <span>Total Amount</span>
          <span className={styles.totalValue}>{formatCurrency(subtotal)}</span>
        </div>
      </div>

      <div className={styles.card}>
        <h4 className={styles.cardTitle}>🚚 Delivery Information</h4>
        <p className={styles.muted}>Expected delivery in 3-5 business days</p>
      </div>

      <div className={styles.notice}>
        <p className={styles.noticeTitle}>⚠️ Important Notice</p>
        <p className={styles.noticeBody}>
          This order will be submitted for approval. You'll receive a confirmation
          notification once it's been processed by the system.
        </p>
      </div>
    </div>
  );
};
